import { Link } from "react-router-dom";
import { FaTrash } from "react-icons/fa";
import { useStore } from "../context/Storecontext";

export default function CartPage() {
  const { cart, removeFromCart, updateCartQty, cartSubtotal } = useStore();
  const shipping = 0;
  const total = cartSubtotal + shipping;

  return (
    <div>
      <div
        className="w-full h-32 bg-cover bg-center relative flex items-center p-8 border-b border-gray-100 overflow-hidden"
        style={{ backgroundImage: "url(/img/bg/banner18.jpg)" }}
      >
        <nav className="text-xs text-gray-400 font-medium tracking-wide justify-center items-center m-auto text-center">
          <h2 className="text-2xl text-black font-semibold mb-2">Cart</h2>
          <Link to="/" className="hover:text-[#43a047] transition-colors">
            Home
          </Link>
          <span className="mx-2 text-gray-300">/</span>
          <span className="text-gray-600">Shopping Cart</span>
        </nav>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10">
        {cart.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-gray-500 mb-4">Your cart is empty.</p>
            <Link
              to="/products"
              className="bg-primary text-white px-6 py-2.5 text-sm hover:bg-primary-dark transition-colors"
            >
              Continue Shopping
            </Link>
          </div>
        ) : (
          <>
            <div className="overflow-x-auto border border-border-color">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b-2 border-primary text-left text-gray-500 uppercase text-xs">
                    <th className="p-4">Delete</th>
                    <th className="p-4">Image</th>
                    <th className="p-4">Product</th>
                    <th className="p-4">Price</th>
                    <th className="p-4">Quantity</th>
                    <th className="p-4">Total</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-border-color">
                  {cart.map((item) => (
                    <tr key={item.id}>
                      <td className="p-4">
                        <button
                          onClick={() => removeFromCart(item.id)}
                          className="text-gray-400 hover:text-red-500"
                        >
                          <FaTrash size={14} />
                        </button>
                      </td>
                      <td className="p-4">
                        <img
                          src={item.img1}
                          alt={item.name}
                          className="w-16 h-16 object-cover border border-border-color"
                        />
                      </td>
                      <td className="p-4 font-medium text-dark hover:text-primary">
                        <Link
                          to={`/product-details/${item.product_id || item.id}`}
                        >
                          {item.name}
                        </Link>
                      </td>
                      <td className="p-4 text-primary font-semibold">
                        ${item.price}.00
                      </td>
                      <td className="p-4">
                        <input
                          type="number"
                          min="1"
                          value={item.qty}
                          onChange={(e) =>
                            updateCartQty(
                              item.id,
                              parseInt(e.target.value) || 1,
                            )
                          }
                          className="w-16 border border-border-color px-2 py-1 text-sm outline-none focus:border-primary"
                        />
                      </td>
                      <td className="p-4 font-semibold text-dark">
                        ${item.price * item.qty}.00
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="flex justify-end p-4 border-t border-border-color">
                <button className="bg-dark text-white text-xs font-semibold px-5 py-2.5 hover:bg-primary transition-colors uppercase">
                  Update Cart
                </button>
              </div>
            </div>

            <div className="flex flex-col lg:flex-row gap-8 mt-10">
              <div className="flex-1 border border-border-color">
                <div className="bg-dark text-white text-sm font-semibold uppercase px-4 py-3">
                  Coupon
                </div>
                <div className="p-4">
                  <p className="text-sm text-gray-500 mb-3">
                    Enter your coupon code if you have one.
                  </p>
                  <div className="flex gap-2">
                    <input
                      type="text"
                      placeholder="Coupon code"
                      className="flex-1 border border-border-color px-3 py-2 text-sm outline-none focus:border-primary"
                    />
                    <button className="bg-dark text-white text-xs font-semibold px-4 uppercase hover:bg-primary transition-colors">
                      Apply Coupon
                    </button>
                  </div>
                </div>
              </div>

              <div className="flex-1 border border-border-color">
                <div className="bg-dark text-white text-sm font-semibold uppercase px-4 py-3">
                  Cart Totals
                </div>
                <div className="p-4">
                  <div className="flex justify-between py-2 border-b border-border-color text-sm">
                    <span className="font-semibold text-dark">Subtotal</span>
                    <span>${cartSubtotal}.00</span>
                  </div>
                  <div className="flex justify-between items-start py-2 border-b border-border-color text-sm">
                    <span className="font-semibold text-dark">Shipping</span>
                    <div className="text-right">
                      <p>Free Shipping</p>
                      <a href="#" className="text-primary text-xs">
                        Calculate shipping
                      </a>
                    </div>
                  </div>
                  <div className="flex justify-between py-3 text-base font-semibold">
                    <span>Total</span>
                    <span className="text-primary">${total}.00</span>
                  </div>
                  <button className="w-full bg-green-600 text-white text-sm font-semibold py-3 hover:bg-green-700 transition-colors">
                    Proceed To Checkout
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
